import React from 'react';

import {FormField, TextInput} from '../../../shared/components';

import {IRegistrationSubStepProps} from '../companyDetails.types';

const RegistrationSubStep: React.FC<IRegistrationSubStepProps> = ({
  registrationFieldLabel,
  registrationError,
  registrationNumber,
  onRegistrationChange,
}) => (
  <div className="company-wizard-card">
    <div className="form-grid">
      <FormField label={registrationFieldLabel} error={registrationError}>
        <TextInput
          type="text"
          value={registrationNumber}
          onChange={(event) => onRegistrationChange(event.target.value)}
          placeholder="e.g. K2019/216138/07"
        />
      </FormField>
    </div>

    <div className="company-info-panel">
      <h4>Do you have a 10 digit registration number?</h4>
      <p>
        If your number is 10 digits, add the relevant last two digits from the
        list below:
      </p>
      <div className="company-info-panel__codes">
        <span>06 = Public Company</span>
        <span>07 = Pty Ltd</span>
        <span>08 = Non Profit Company</span>
        <span>21 = Incorporations</span>
        <span>23 = Close Corporations</span>
        <span>30 = State Owned Company</span>
      </div>
    </div>
  </div>
);

export default RegistrationSubStep;

export {RegistrationSubStep};
